<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-message-header
        icon="check"
        text="Je registratie is gelukt"
        :success="true"
      />
      <o-section>
        <p>
          Je Q8-smiles account werd aangemaakt. Je kan vanaf nu eenvoudig gaan
          tanken bij Q8.
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Start" to="/sales/fuel/q8/stations/loading " />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OMessageHeader,
    OPayButton
  }
}
</script>

<style lang="scss"></style>
